$(document).ready(function () {
  $("a.main-menu-extend-item").click(function () {
    $(this).next().toggle();
    if ($("i.ad.ad-minus-l").hasClass("ad-minus-l")) {
      $("i.ad.ad-minus-l").removeClass("ad-minus-l");
       $("i.ad").addClass("ad-plus-l");
    } else {
      $("i.ad.ad-minus-l").removeClass("ad-plus-l");
      $("i.ad").addClass("ad-minus-l");
    }
  });
});
